import Long from 'long';

export default function formatTimeout(timeout?: Long | null): string {
  const seconds: number = timeout?.toNumber() || 0;

  if (seconds < 60) return `${seconds}s`;

  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  const parts: string[] = [];
  if (hours) parts.push(`${hours}h`);
  if (mins) parts.push(`${mins}m`);
  if (s) parts.push(`${s}s`);
  return parts.join(' ');
}
